import { render, staticRenderFns } from "./activityFeeReceipt.html?vue&type=template&id=1b8b0852&scoped=true&"
import script from "./activityFeeReceipt.vue?vue&type=script&lang=js&"
export * from "./activityFeeReceipt.vue?vue&type=script&lang=js&"
import style0 from "./activityFeeReceipt.css?vue&type=style&index=0&id=1b8b0852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8b0852",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
